import { useEffect, useState } from "react"
import { FilterProps } from "../../../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../../../utils/methods/removedReference"
import { InputModel } from "../../../../../../utils/types"
import { Item } from "../../../../../../utils/types/generals"
import { useDashboardMainContext } from "../../provider"
import { currentWeek } from "../methods/calcDates"
import { Box, Typography } from "@mui/material"
import { intervaleList } from "../../../../../../utils/constants/intervaleList"
import { useTranslation } from "react-i18next"
import { statusService } from "../../../../../../service/status"

const useInput = () => {
    const { items } = useDashboardMainContext()
    const [input, setInput] = useState<Record<string, InputModel>>({})
    const { t } = useTranslation()

    const externalValidation: FilterProps['externalValidation'] = ({ name, value, body, setFilterData }) => {
        let copyBody: Record<string, any> = removeAllReference(body)
        if (name === 'areas') {
            const { areas, departments: departmentsData } = copyBody
            const newDepartments = departmentsData?.filter((e: any) => areas.find((e2: any) => e2.value === e.areaId))
            let arrayChilds: any[] = []

            areas?.forEach((e: any) => {
                const id = e.value
                const childs = (items?.departments as Item[])?.filter((child) => child.areaId === id)
                arrayChilds.push(...childs)
            })

            setInput(prev => ({ ...prev, departments: { ...prev.departments, items: arrayChilds, } }))
            setFilterData((prev) => ({
                ...prev,
                departments: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                departments: newDepartments,
            }
        }
        return copyBody
    }

    const removeValues = () => {
        setInput(prev => ({
            ...prev,
            from: {
                ...prev.from,
                value: null
            },
            to: {
                ...prev.to,
                value: null
            },
        }))
    }
    useEffect(() => {
        setInput({
            intervale: {
                label: 'general.tags.intervale',
                translate: true,
                name: 'intervale',
                type: 'select-search',
                items: intervaleList,
                value: intervaleList[0],
                wrapChildren: ({ children, id }) => {
                    return (
                        <Box key={id}>
                            <Typography sx={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#707070',
                                marginBottom: '20px',
                            }}>{t('general.intervale.intervale')}</Typography>

                            {children}
                        </Box>
                    )
                }
            },
            from: {
                label: 'general.tags.from',
                translate: true,
                name: 'from',
                type: 'date',
                value: null,
                rest: {
                    max: 'to',
                },
                size: {
                    xl: 6,
                    lg: 6,
                    md: 6,
                    sm: 6,
                    xs: 6,
                },
                wrapChildren: ({ children, id }) => {
                    return (
                        <Box key={id}>
                            <Typography sx={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#707070',
                                marginBottom: '20px',
                            }}>{t('general.filters')}</Typography>

                            {children}
                        </Box>
                    )
                }
            },
            to: {
                label: 'general.tags.to',
                translate: true,
                name: 'to',
                type: 'date',
                rest: {
                    min: 'from',
                },
                value: currentWeek().end.getTime(),
                size: {
                    xl: 6,
                    lg: 6,
                    md: 6,
                    sm: 6,
                    xs: 6,
                },
                itemChildren: {
                    alignSelf: "end"
                }
            },
            areas: {
                label: 'general.tags.areas',
                translate: true,
                name: 'areas',
                type: 'filter-select',
                items: items?.areas as Item[] || [],
                value: null,
            },
            departments: {
                label: 'general.tags.departments',
                translate: true,
                name: 'departments',
                type: 'filter-select',
                items: [],
                value: null,
            },
            questionnaire: {
                label: 'general.tags.questionnaires',
                translate: true,
                name: 'questionnaire',
                type: 'filter-select',
                items: items.questionnaire as Item[] || [],
                value: null,
            },
            percentage: {
                label: 'Promedio de avance',
                name: 'percentage',
                type: 'percentage',
                value: null,

            },
            divisions: {
                label: 'general.tags.divisions',
                translate: true,
                name: 'divisions',
                type: 'filter-select',
                items: items.division as Item[] || [],
                value: null,
            },
            units: {
                label: 'general.tags.unit',
                translate: true,
                name: 'units',
                type: 'filter-select',
                items: items.unit as Item[] || [],
                value: null,
                size: {
                    xl: 12,
                    lg: 12,
                    md: 12,
                    sm: 12,
                },
            },
            users: {
                label: 'general.tags.users',
                translate: true,
                name: 'users',
                type: 'filter-select',
                items: items.users as Item[] || [],
                value: null,
            },
            estatus: {
                label: 'general.tags.status',
                translate: true,
                name: 'estatus',
                type: 'filter-select',
                items: statusService().statusListAsItems(),
                value: null,
            },
        })
    }, [items])
    return {
        externalValidation,
        input,
        removeValues,
        items
    }
}

export { useInput }
